<template lang="pug">
UpsertPage(
  title="Dashboard Configuration"
  @save="validateAndSave"
  save-label="Save"
  :pending="isSaving || isFetching"
  hide-cancel
  )
  BriqPanel
    .mb-S(v-if="noDashboards") No dashboard configuration
    .dashboard-line.mb-S(v-else v-for="(d, index) in dashboards")
      BriqInput(
        label="Dashboard id"
        v-model="d.DashboardId"
        required
        :disabled="isSaving"
        @blur="touch('DashboardId', index)"
        :error="getError('DashboardId', index)"
        )
      BriqInput(
        label="Label"
        v-model="d.Label"
        required
        :disabled="isSaving"
        @blur="touch('Label', index)"
        :error="getError('Label', index)"
        )
      BriqCheckbox.global-checkbox(
        label="Global"
        v-model="d.IsGlobal"
        :disabled="isSaving"
        )
      button.remove-button.ml-S(@click="removeDashboard(index)")
        BriqIcon(name="icon-input-trash-icon")
    BriqButton(@click="addDashboard" :disabled="isSaving") Add dashboard
</template>

<script>
import UpsertPage from '@v/components/UpsertPage.vue'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'DashboardConfiguration',
  components: { UpsertPage },
  props: {
    dashboards: Array,
    isFetching: Boolean,
    isSaving: Boolean,
  },
  validations: {
    dashboards: {
      $each: {
        DashboardId: { required },
        Label: { required },
      },
    },
  },
  computed: {
    noDashboards() {
      return !this.dashboards || this.dashboards.length === 0
    },
  },
  methods: {
    validateAndSave() {
      this.$v.dashboards.$touch()
      if (!this.$v.$invalid) this.$emit('save', this.dashboards)
      else this.$notifyError('Please fill out the required fields')
    },
    addDashboard() {
      this.dashboards.push({
        Key: '',
        DashboardId: '',
        Label: '',
        IsGlobal: false,
        Order: 1,
      })
    },
    removeDashboard(index) {
      this.dashboards.splice(index, 1)
    },
    touch(field, index) {
      this.$v.dashboards.$each[index][field].$touch()
    },
    getError(field, index) {
      const validationState = this.$v.dashboards.$each[index][field]
      const fieldMessage = field === 'DashboardId' ? 'Dashboard id' : 'Label'
      const error =
        validationState.$dirty && validationState.$error && `${fieldMessage} is required`
      return error || ''
    },
  },
}
</script>

<style scoped lang="stylus">
.dashboard-line
  display flex

  .briq-input
    margin-right 24px

  .global-checkbox
    width 250px
    margin-top 27px

.remove-button
  margin 0 auto
  cursor pointer
  margin-top 20px
  padding 0 10px
</style>
